import React from 'react';

import { Element } from '@americanexpress/aqx-components';
import styles from './__styles__/index.scss?modules';

export const SectionTitle = ({ text }) =>
  !!text && (
    <Element Component="h2" className={styles.sectionTitle}>
      {text}
    </Element>
  );
